module.exports = __webpack_public_path__ + "media/images/icons/icons_small/61_foreverSign-73bf0753e9aaff7d266796a17b5ffdc9.png";